import { createRouter, createWebHashHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { ElMessage, ElMessageBox } from 'element-plus'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/loginpda',
    name: 'LoginPda',
    component: () => import('../views/LoginPda.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/main',
    name: 'Main',
    component: () => import('../views/Main.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/receiving',
    name: 'Receiving',
    component: () => import('../views/Receiving.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/receiving/register/:orderNumber',
    name: 'ReceivingRegister',
    component: () => import('../views/ReceivingRegister.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/receiving/register-no-order',
    name: 'ReceivingRegisterNoOrder',
    component: () => import('../views/ReceivingRegisterNoOrder.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/shipping',
    name: 'Shipping',
    component: () => import('../views/Shipping.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/shipping/register/:orderNumber',
    name: 'ShippingRegister',
    component: () => import('../views/ShippingRegister.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/shipping-inspection',
    name: 'ShippingInspection',
    component: () => import('../views/ShippingInspection.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/shipping-inspection/register/:orderNumber',
    name: 'ShippingInspectionRegister',
    component: () => import('../views/ShippingInspectionRegister.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/member-receiving',
    name: 'MemberReceiving',
    component: () => import('../views/MemberReceiving.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/member-receiving/register/:orderNumber',
    name: 'MemberReceivingRegister',
    component: () => import('../views/MemberReceivingRegister.vue'),
    meta: { requiresAuth: true }
  },
        {
          path: '/inventory',
          name: 'Inventory',
          component: () => import('../views/Inventory.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/inventory-move',
          name: 'InventoryMove',
          component: () => import('../views/InventoryMove.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/inventory-audit',
          name: 'InventoryAudit',
          component: () => import('../views/InventoryAudit.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/barcode-register',
          name: 'BarcodeRegister',
          component: () => import('../views/BarcodeRegister.vue'),
          meta: { requiresAuth: true }
        },
        // 관리자 화면
        {
          path: '/admin',
          component: () => import('../layouts/AdminLayout.vue'),
          meta: { requiresAuth: true },
          children: [
            {
              path: 'dashboard',
              name: 'AdminDashboard',
              component: () => import('../views/admin/Dashboard.vue'),
              meta: { requiresAuth: true }
            },
            {
              path: 'users',
              name: 'UserManagement',
              component: () => import('../views/admin/UserManagement.vue'),
              meta: { requiresAuth: true }
            },
            {
              path: 'login-history',
              name: 'LoginHistory',
              component: () => import('../views/admin/LoginHistory.vue'),
              meta: { requiresAuth: true }
            },
            {
              path: 'product-list',
              name: 'ProductList',
              component: () => import('../views/admin/ProductList.vue'),
              meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'WAREHOUSE', 'COOP_MEMBER', 'COOP_NONMEMBER'] }
            },
            {
              path: 'product-inventory-status',
              name: 'ProductInventoryStatus',
              component: () => import('../views/admin/ProductInventoryStatus.vue'),
              meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'WAREHOUSE', 'COMPANY'] }
            },
            {
              path: 'product-location-inventory',
              name: 'ProductLocationInventory',
              component: () => import('../views/admin/ProductLocationInventory.vue'),
              meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'WAREHOUSE'] }
            },
            {
              path: 'unsold-status',
              name: 'UnsoldStatus',
              component: () => import('../views/admin/UnsoldStatus.vue'),
              meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'WAREHOUSE'] }
            },
            {
              path: 'product-send-history',
              name: 'ProductSendHistory',
              component: () => import('../views/admin/ProductSendHistory.vue'),
              meta: { requiresAuth: true, requiresAdmin: true }
            },
            {
              path: 'order-register',
              name: 'OrderRegister',
              component: () => import('../views/admin/OrderRegister.vue'),
              meta: { requiresAuth: true }
            },
            {
              path: 'order-sheet-inquiry',
              name: 'OrderSheetInquiry',
              component: () => import('../views/admin/OrderSheetInquiry.vue'),
              meta: { requiresAuth: true }
            },
            {
              path: 'order-history',
              name: 'OrderHistory',
              component: () => import('../views/admin/OrderHistory.vue'),
            },
            {
              path: 'notice-board',
              name: 'NoticeBoardManagement',
              component: () => import('../views/admin/NoticeBoardManagement.vue'),
              meta: { requiresAuth: true }
            },
            {
              path: 'notice-board/write',
              name: 'NoticeBoardWrite',
              component: () => import('../views/admin/NoticeBoardWrite.vue'),
              meta: { requiresAuth: true }
            },
            {
              path: 'group-buy-requests',
              name: 'GroupBuyRequests',
              component: () => import('../views/admin/GroupBuyRequests.vue'),
              meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'WAREHOUSE'] }
            },
            {
              path: 'receiving-request-history',
              name: 'ReceivingRequestHistory',
              component: () => import('../views/admin/ReceivingRequestHistory.vue'),
            },
            {
              path: 'receiving-history',
              name: 'ReceivingHistory',
              component: () => import('../views/admin/ReceivingHistory.vue'),
            },
            {
              path: 'shipping-history',
              name: 'ShippingHistory',
              component: () => import('../views/admin/ShippingHistory.vue'),
              meta: { requiresAuth: true }
            },
            {
              path: 'shipping-inspection-history',
              name: 'ShippingInspectionHistory',
              component: () => import('../views/admin/ShippingInspectionHistory.vue'),
              meta: { requiresAuth: true }
            },
            {
              path: 'audit-history',
              name: 'AuditHistory',
              component: () => import('../views/admin/AuditHistory.vue'),
              meta: { requiresAuth: true }
            },
            {
              path: 'inventory-move-history',
              name: 'InventoryMoveHistory',
              component: () => import('../views/admin/InventoryMoveHistory.vue'),
              meta: { requiresAuth: true }
            },
            {
              path: 'app-versions',
              name: 'AppVersionManagement',
              component: () => import('../views/admin/AppVersionManagement.vue'),
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: '/app-download',
          name: 'AppDownload',
          component: () => import('../views/AppDownload.vue')
        }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 뒤로/앞으로 버튼을 사용한 경우 저장된 위치로 스크롤
    if (savedPosition) {
      return savedPosition
    }
    // 새로고침이나 직접 URL 접근의 경우 맨 위로
    return { top: 0 }
  }
})

// 청크 로드 실패 시(배포 갱신·캐시 등) 새로고침하여 최신 자산 로드
router.onError((error) => {
  const isChunkLoadError =
    error?.name === 'ChunkLoadError' ||
    (error?.message && (
      String(error.message).includes('Loading chunk') ||
      String(error.message).includes('Failed to fetch dynamically imported module')
    ))
  if (isChunkLoadError) {
    window.location.reload()
    return
  }
  throw error
})

// 네비게이션 가드
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  // 인증 상태 초기화 (토큰이 있으면)
  if (!authStore.isAuthenticated && localStorage.getItem('token')) {
    authStore.initializeAuth()
  }
  
  // URL에 'loginpda'가 포함되어 있는지 확인
  const currentUrl = window.location.href
  const isLoginPdaUrl = currentUrl.includes('loginpda')
  
  // /loginpda 경로인지 확인
  const isLoginPdaPath = to.path === '/loginpda'
  
  // URL에 'loginpda'가 포함되어 있고 루트 경로나 /login 경로로 접근하는 경우 /loginpda로 리다이렉트
  if ((to.path === '/' || to.path === '/login') && isLoginPdaUrl) {
    next('/loginpda')
    return
  }
  
  // /loginpda 경로이고 이미 인증된 경우 - 관리자/사무국/회원사/조합원/비조합원 권한 체크
  if (isLoginPdaPath && authStore.isAuthenticated) {
    const userRole = authStore.user?.role
    const allowedPdaRoles = ['ADMIN', 'WAREHOUSE', 'COMPANY', 'COOP_MEMBER', 'COOP_NONMEMBER']
    if (!allowedPdaRoles.includes(userRole)) {
      await authStore.logout()
      next()
      return
    }
    // 사무국와 회원사는 이미 로그인되어 있으므로 메인 화면으로 이동
    // 단, 이미 /main으로 이동 중이면 무한 루프 방지를 위해 그냥 통과
    if (from.path !== '/main') {
      next('/main')
      return
    }
  }
  
  // /admin 경로로 직접 접근하는 경우 권한에 따라 리다이렉트
  if (to.path === '/admin' && authStore.isAuthenticated) {
    const userRole = authStore.user?.role
    if (userRole === 'ADMIN') {
      next('/admin/dashboard')
    } else if (userRole === 'PARTNER') {
      next('/admin/receiving-request-history')
    } else if (userRole === 'COMPANY' || userRole === 'COOP_MEMBER' || userRole === 'COOP_NONMEMBER') {
      next('/admin/order-register')
    } else {
      next('/login')
    }
    return
  }
  
  // 쿠키에서 loginpda 기록 확인
  const getCookie = (name) => {
    const nameEQ = `${name}=`
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  }
  
  const isLoginPdaCookie = getCookie('loginpda') === 'true'

  // 인증이 필요한 페이지인 경우
  if (to.meta.requiresAuth) {
    // 인증되지 않은 경우
    if (!authStore.isAuthenticated) {
      // 쿠키에 loginpda 기록이 있으면 /loginpda로, 없으면 /login으로 리다이렉트
      if (isLoginPdaCookie || isLoginPdaUrl) {
        next('/loginpda')
      } else {
        next('/login')
      }
      return
    }
    
    // 로그인 날짜 확인 (오늘이 아니면 로그아웃)
    if (!authStore.isLoginToday()) {
      // localStorage의 token, user, loginDate 제거
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('loginDate')
      
      try {
        await ElMessageBox.alert(
          '다시 로그인 해주세요',
          '세션 만료',
          {
            confirmButtonText: '확인',
            type: 'warning'
          }
        )
      } catch (error) {
        // 확인 버튼 클릭 시 처리
      }
      
      await authStore.logout()
      
      // 현재 경로에 따라 적절한 로그인 화면으로 이동
      const currentPath = to.path || from.path || window.location.hash.replace('#', '')
      if (currentPath.includes('loginpda') || isLoginPdaCookie || isLoginPdaUrl) {
        next('/loginpda')
      } else {
        next('/login')
      }
      return
    }

    // 협력업체: 입고요청내역 화면만 접근
    const userRole = authStore.user?.role
    if (userRole === 'PARTNER' && to.path.startsWith('/admin')) {
      if (to.path !== '/admin/receiving-request-history') {
        next('/admin/receiving-request-history')
        return
      }
    }

    if (to.meta.allowedRoles && !to.meta.allowedRoles.includes(userRole)) {
      if (userRole === 'ADMIN') {
        next('/admin/dashboard')
      } else if (userRole === 'PARTNER') {
        next('/admin/receiving-request-history')
      } else if (['COMPANY', 'COOP_MEMBER', 'COOP_NONMEMBER'].includes(userRole)) {
        next('/admin/order-register')
      } else if (userRole === 'WAREHOUSE') {
        next('/main')
      } else {
        next('/login')
      }
      return
    }
  }
  
  // 게스트 전용 페이지인데 이미 인증된 경우
  if (to.meta.requiresGuest && authStore.isAuthenticated) {
    // 로그인 화면에서는 세션 만료 체크를 하지 않음 (로그인 시도 중이거나 로그인 성공 직후일 수 있음)
    // 로그인 날짜 확인은 로그인 화면이 아닌 다른 페이지에서만 수행
    if (to.path !== '/login' && to.path !== '/loginpda') {
      // 로그인 날짜 확인 (오늘이 아니면 로그아웃)
      if (!authStore.isLoginToday()) {
        // localStorage의 token, user, loginDate 제거
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('loginDate')
        
        // 세션 만료 팝업이 표시되었음을 표시 (로그인 성공 메시지 표시 방지용)
        sessionStorage.setItem('sessionExpiredShown', 'true')
        
        try {
          await ElMessageBox.alert(
            '다시 로그인 해주세요',
            '세션 만료',
            {
              confirmButtonText: '확인',
              type: 'warning'
            }
          )
        } catch (error) {
          // 확인 버튼 클릭 시 처리
        }
        
        await authStore.logout()
        
        // 현재 경로에 따라 적절한 로그인 화면으로 이동
        const currentPath = to.path || from.path || window.location.hash.replace('#', '')
        if (currentPath.includes('loginpda') || isLoginPdaCookie || isLoginPdaUrl) {
          next('/loginpda')
        } else if (currentPath.includes('login')) {
          next('/login')
        } else {
          // 현재 경로가 로그인 화면이 아니면 쿠키에 따라 결정
          if (isLoginPdaCookie || isLoginPdaUrl) {
            next('/loginpda')
          } else {
            next('/login')
          }
        }
        return
      }
    }
    
    // /loginpda 경로는 위에서 이미 처리했으므로 여기서는 제외
    if (isLoginPdaPath) {
      next()
      return
    }
    
    // /login 경로로 접근하는데 쿠키에 loginpda 기록이 있으면 /loginpda로 리다이렉트
    if (to.path === '/login' && isLoginPdaCookie) {
      next('/loginpda')
      return
    }
    
    // 사용자 역할에 따라 리다이렉트
    const userRole = authStore.user?.role
    if (userRole === 'ADMIN') {
      next('/admin/dashboard')
    } else if (userRole === 'PARTNER') {
      next('/admin/receiving-request-history')
    } else if (userRole === 'COMPANY' || userRole === 'COOP_MEMBER' || userRole === 'COOP_NONMEMBER') {
      // 회원사는 loginpda 쿠키가 있으면 메인 화면으로, 없으면 주문관리 화면으로
      if (isLoginPdaCookie || isLoginPdaUrl) {
        // 이미 /main에 있으면 다시 이동하지 않음
        if (to.path !== '/main') {
          next('/main')
        } else {
          next()
        }
      } else {
        next('/admin/order-register')
      }
    } else if (userRole === 'WAREHOUSE') {
      // 이미 /main에 있으면 다시 이동하지 않음
      if (to.path !== '/main') {
        next('/main')
      } else {
        next()
      }
    } else {
      // 이미 /main에 있으면 다시 이동하지 않음
      if (to.path !== '/main') {
        next('/main')
      } else {
        next()
      }
    }
    return
  }
  
  next()
})

export default router
